import { Base, withMountWhenInView } from '@studiometa/js-toolkit';

/**
 * Reveal class.
 */
export default class Reveal extends withMountWhenInView(Base, {
  threshold: [0.2, 1],
}) {
  static config = {
    name: 'Reveal',
  };

  /**
   * Mounted.
   * @returns {void}
   */
  mounted() {
    this.$el.classList.add('is-reveal');
  }
}
